"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.table.shortcut': '快捷键',
    'shortcuts.table.description': '描述',
};
